import React from "react";
import { graphql } from "gatsby";
import { Box, Button, Hidden } from "@material-ui/core";
import Imgix from "react-imgix";
import {
  CustomButtonWrapper,
  CustomDescriptionTypography,
  CustomTipsTypography,
  ImageWrapper
} from "./styles";
import ExpressDeliveryLogo from "../../containers/express-delivery/ExpressDeliveryLogo";
import ShopingCartIcon from "../../components/icons/shopping-cart";
import LocalizedLink from "../../components/localized-link";
import { SHOP_BASEPATH } from "../../helpers/url";
import useTranslate from "../../hooks/use-translate";

export default function ExpressDeliveryInfoSection({ image }: Queries.ExpressDeliveryInfoSectionFragmentFragment) {
  const t = useTranslate();
  const copy = {
    title: "XPRESS is here to deliver.",
    description:
      "XPRESS connects you to delivering dispensaries across California. Discover the freshest Airgraft pods and get them delivered to your door.",
    tips: 'XPRESS delivery is fulfilled by licensed delivering dispensaries & products may differ depending on region. For a full listing of cities, <a href="https://intercom.help/airgraft/en/articles/4836980-where-are-airgraft-2-battery-and-vapor-pods-available-for-purchase" target="_blank">click here.'
  };
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      maxWidth="100vw"
      overflow="hidden"
    >
      {/* Desktop */}
      <ImageWrapper>
        <Imgix
          src={image.url}
          width={730}
          imgixParams={{
            auto: "format,compress"
          }}
        />
      </ImageWrapper>
      {/* Desktop */}
      <Hidden smDown implementation="css">
        <ExpressDeliveryLogo height="38px" />
      </Hidden>
      {/* Mobile */}
      <Hidden mdUp implementation="css">
        <ExpressDeliveryLogo height="24px" />
      </Hidden>
      <CustomDescriptionTypography variant="h5" align="center">
        {copy.description}
      </CustomDescriptionTypography>
      <CustomButtonWrapper>
        <Button
          variant="contained"
          color="primary"
          className="express-delivery MuiButton-sizeXLarge"
          fullWidth
          component={LocalizedLink}
          to={SHOP_BASEPATH}
          startIcon={<ShopingCartIcon />}
        >
          {t("browseProducts")}
        </Button>
      </CustomButtonWrapper>
      {/* Desktop */}
      <Hidden smDown implementation="css">
        <CustomTipsTypography
          variant="body1"
          align="center"
          dangerouslySetInnerHTML={{ __html: copy.tips }}
        />
      </Hidden>
      {/* Mobile */}
      <Hidden mdUp implementation="css">
        <CustomTipsTypography
          variant="caption"
          align="center"
          dangerouslySetInnerHTML={{ __html: copy.tips }}
        />
      </Hidden>
    </Box>
  );
}

export const ExpressDeliveryInfoSectionFragment = graphql`
  fragment ExpressDeliveryInfoSectionFragment on DatoCmsCModuleExpressDeliveryInfo {
    image {
      url
    }
    container
    containerDisableGutters
    containerBackgroundColor
    visibilitySettings {
      ...ContentModuleVisibilitySettingFragment
    }
    model {
      apiKey
    }
  }
`;
